<div class="container">
  <h1 class="row big-title">Select your packs:</h1>
  <div class="row m-4 showRow">
    <h2 class="col-12">Quality of life</h2>
    <div *ngFor="let resource of Resources" class="col">
      <app-project-card [project]="resource" class="px-2"></app-project-card>
    </div>
  </div>
</div>
